import React from 'react'
import styled from 'styled-components'
import { Button, Stack, Badge, HStack, VStack } from '@chakra-ui/react'
import { Link } from 'react-router-dom';

const Container = styled.div`
    width: 325px;
    height: 100%;
    padding: 10px;
    border: 2px solid #DADADA;
    border-radius: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;

    @media screen and (max-width: 873px){
        flex-direction: column-reverse;
        height: 345px;
        min-width: 360px;
        width: 360px;
     };
`;

const WrapText = styled.section`
    display: flex;
    flex-direction: column;
    font-size: 13px;
    width: 300px;
    min-height: 50px;
    text-align: left;

    @media screen and (max-width: 873px){
        margin-left: 38px;
        margin-bottom: 31px;
        width: 219px;
    };
`;

const StatusBox = styled.div`
     display: flex;
     width: 100px;
     height: 35px;
     padding: 5px;
     margin-right: 0;
     margin-left: auto;
     background: #6554C0;
     color: #FFFFFF;
     border-radius: 5px;
     justify-content: center;
`;

const DetailsBox = styled.div`
     display: flex;
     height: 35px;
     margin-top: 5px;
     padding: 5px;
     margin-left: auto;
     border: 2px solid #6554C0;
     border-radius: 5px;
     justify-content: center;
`;

const CardProposal = ({
    id,
    kegiatan,
    posisi,
    status}) => {
   
    return (
        <Container>
            <Stack>
                <HStack align="end" style={{display: 'flex', marginRight: '0', marginLeft: 'auto'}}>
                    {status == "Dipublikasikan" ? (
                       <Badge p={2} m={2} colorScheme='green' fontSize='12px'>{status}</Badge>
                        ) : (
                        status == "Ditolak" ? (
                            <Badge p={2} m={2} colorScheme='red' fontSize='12px'>{status}</Badge>
                        ) : (
                        status == "Butuh Revisi" ? (
                            <Badge p={2} m={2} colorScheme='yellow' fontSize='12px'>{status}</Badge>
                        ) : (
                            <Badge p={2} m={2} colorScheme='purple' fontSize='12px'>{status}</Badge>
                    )))}
                </HStack>
                <WrapText>
                    <span style={{fontSize: '18px'}}>{kegiatan}</span>
                    <div style={{paddingTop: '20px', fontWeight: '600', fontSize: '13px', marginBottom: '5px', textAlign: 'left'}}>{posisi}</div>
                </WrapText>
                <Link to={`/mitra/profile/proposal/detail/${id}`}><DetailsBox>See Details</DetailsBox></Link>
            </Stack>
       </Container>
    )
}

export default CardProposal
